export default __webpack_public_path__ + "static/media/08.83a5054f.jpg";